import React from 'react';
const Search = ({ className, ...r }) => {
	return (
		<svg
			className={className}
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 224 192"
			{...r}
		>
			<path
				fill="#FDB727"
				fillRule="evenodd"
				d="M13.086 105.22l-2.162.684-.684-2.162a1.061 1.061 0 00-2.023.64l.685 2.162-2.162.685a1.061 1.061 0 00.642 2.023l2.16-.685.684 2.161a1.063 1.063 0 001.332.691c.559-.176.868-.774.692-1.331l-.684-2.162 2.161-.684a1.06 1.06 0 00-.64-2.022z"
				clipRule="evenodd"
			></path>
			<path
				fill="#081FA0"
				fillRule="evenodd"
				d="M182.987 25.322a2.497 2.497 0 01-4.981.35 2.498 2.498 0 012.317-2.666 2.498 2.498 0 012.664 2.316z"
				clipRule="evenodd"
			></path>
			<path
				fill="#EAEBFF"
				fillRule="evenodd"
				d="M195.987 167.321a2.498 2.498 0 01-2.315 2.666 2.498 2.498 0 01-2.666-2.315 2.499 2.499 0 012.317-2.666 2.499 2.499 0 012.664 2.315zm-167-125.999a2.498 2.498 0 01-4.98.35 2.498 2.498 0 014.98-.35z"
				clipRule="evenodd"
			></path>
			<path
				fill="#126FFF"
				fillRule="evenodd"
				d="M35.285 158.173a.791.791 0 00-.994-.516l-1.614.512-.511-1.616a.791.791 0 10-1.51.479l.51 1.615-1.613.511a.792.792 0 00.478 1.51l1.614-.512.51 1.615a.794.794 0 00.995.515.792.792 0 00.516-.994l-.511-1.613 1.615-.512a.792.792 0 00.515-.994z"
				clipRule="evenodd"
			></path>
			<path
				fill="#EAEBFF"
				fillRule="evenodd"
				d="M217.285 84.173a.79.79 0 00-.994-.516l-1.614.512-.511-1.615a.792.792 0 10-1.51.478l.511 1.615-1.614.51a.793.793 0 00.478 1.51l1.614-.51.511 1.614a.793.793 0 001.51-.48l-.511-1.612 1.615-.512a.793.793 0 00.515-.994z"
				clipRule="evenodd"
			></path>
			<path
				fill="#126FFF"
				fillRule="evenodd"
				d="M93.285 10.173a.791.791 0 00-.994-.516l-1.614.512-.512-1.616a.792.792 0 10-1.51.479l.512 1.614-1.614.512a.792.792 0 00.478 1.51l1.614-.511.51 1.614a.793.793 0 00.995.515.792.792 0 00.516-.994l-.511-1.613 1.615-.512a.792.792 0 00.515-.994z"
				clipRule="evenodd"
			></path>
			<circle
				cx="116"
				cy="103"
				r="80"
				stroke="#F2F2F2"
				strokeDasharray="2 8"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
			></circle>
			<circle
				cx="116"
				cy="103"
				r="64"
				stroke="#F2F2F2"
				strokeDasharray="2 8"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
			></circle>
			<g clipPath="url(#search-a)">
				<path
					fill="#0250C9"
					d="M137.477 118.218l12.27 16.368a4.83 4.83 0 01-6.829 0l-10.904-10.904 5.463-5.464z"
				></path>
				<path
					fill="#126FFF"
					d="M134.745 120.95l10.904 10.904c1.886 1.886 3.721 3.109 4.098 2.732a4.83 4.83 0 000-6.83l-10.904-10.904-4.098 4.098z"
				></path>
				<path
					fill="#FFC968"
					d="M137.483 118.216l-6.828-6.829-4.097 4.097 6.828 6.829 4.097-4.097z"
				></path>
				<path
					fill="#EF9B30"
					d="M132.703 107.982l1.785 4.172a.967.967 0 01-.205 1.063l-5.905 5.905a.967.967 0 01-1.063.205l-4.173-1.785 9.561-9.56zm-2.055 14.334l2.731-2.732 2.732 2.732-2.732 2.732a1.931 1.931 0 11-2.731-2.732z"
				></path>
				<path
					fill="#FDB727"
					d="M133.379 122.316a1.933 1.933 0 010-2.732l4.098-4.097a1.93 1.93 0 112.732 2.731l-4.098 4.098a1.933 1.933 0 01-2.732 0zm-21.944-1.768c-13.406 0-24.274-10.868-24.274-24.274S98.029 72 111.435 72s24.273 10.868 24.273 24.274-10.867 24.274-24.273 24.274z"
				></path>
				<path
					fill="#E4E4E4"
					d="M111.435 75.863v40.821c-11.273 0-20.411-9.138-20.411-20.41 0-11.273 9.138-20.41 20.411-20.41z"
				></path>
				<path
					fill="#F7F7F4"
					d="M94.887 96.274c0-11.273 7.409-20.41 16.548-20.41 11.272 0 20.41 9.137 20.41 20.41 0 11.272-9.138 20.41-20.41 20.41-9.139 0-16.548-9.138-16.548-20.41z"
				></path>
			</g>
			<defs>
				<clipPath id="search-a">
					<path
						fill="#fff"
						d="M0 0h64v64H0z"
						transform="matrix(-1 0 0 1 151.161 72)"
					></path>
				</clipPath>
			</defs>
		</svg>
	);
};

export default Search;
